import { unstable_memoTheme } from '@mui/system';
import { Theme } from '../styles/createTheme';

const memoTheme = unstable_memoTheme<Theme>;

export default memoTheme;
